import script from "./DetailsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsPanel.vue?vue&type=style&index=0&id=3da3db80&lang=scss"

const __exports__ = script;

export default __exports__